import React, { useContext, useState, useEffect } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { FloatCardComponent } from "../../components/cards";
import GirasTableComponent from "../../components/tables/GirasTableComponent";
import LabelFieldComponent from "../../components/fields/LabelFieldComponent";
import { PaginationComponent } from "../../components";
import PageLayout from "../../layouts/PageLayout";
import products from "../../assets/data/giras.json";
import {getEstablecimientos, getRegiones, getComunas, getProgramas, getTramos, getReporteGiras, getReportePagos, getReporteTallas} from "../../api/mantenedores.ts";
import {creaGira, getGiras} from "../../api/giras.ts";
import Swal from 'sweetalert2';
import { AnchorComponent, ButtonComponent } from "../../components/elements";
import { useAuthStore } from "../../store/auth.store.ts";

export default function GirasListPage() {

    const { t, n } = useContext(TranslatorContext);
    const { usuario } = useAuthStore((state) => state);

    const [selectEstablecimiento, setSelectEstablecimiento] = useState([]);
    const [selectRegion, setSelectRegion] = useState([]);
    const [selectComuna, setSelectComuna] = useState([]);
    const [selectPrograma, setSelectPrograma] = useState([]);
    const [selectTramo, setSelectTramo] = useState([]);
    const [comunas, setComunas] = useState([]);
    const [anioFiltro, setAnioFiltro] = useState(new Date().getFullYear());
    const [reporteGiras, setReporteGiras] = useState([]);
    
    // Estados para el modal de reporte de pagos
    const [showReportModal, setShowReportModal] = useState(false);
    const [reportData, setReportData] = useState({
        fechaInicio: new Date().toLocaleDateString('en-CA'), // Formato YYYY-MM-DD en zona horaria local
        fechaFin: new Date().toLocaleDateString('en-CA')
    });

    // Estados para el modal de reporte de tallas
    const [showReportTallasModal, setShowReportTallasModal] = useState(false);
    const [reportTallasData, setReportTallasData] = useState({
        anio: new Date().getFullYear()
    });

    const anioActual =new Date().getFullYear();
    const anios = [];
    for (let year = 2025; year <= 2028; year++) {
        anios.push(year);
    }

       
    const [alertModal, setAlertModal] = useState(false);

    const [giras, setGiras] = useState([]);
    const [girasFiltradas, setGirasFiltradas] = useState([]);
        useEffect(() => {


            const fectchProgramas = async () => {
                const res = await getProgramas();
                console.log(res);
                setSelectPrograma(res.data);
            }

            const fectchTramos = async () => {
                const res = await getTramos();
                console.log(res);
                setSelectTramo(res.data);
            }

           

            const fecthregiones = async () => {
                const res = await getRegiones();
                console.log(res);
                setSelectRegion(res.data);
            }   
    
            const fecthComunas = async () => {
                const res = await getComunas();
                console.log(res);
                setSelectComuna(res.data);
            }

            const fetchTabla = async () => {
                const res = await getGiras();
                
                setGiras(res);
                  // Filtrar giras por el año actual al cargar
                const girasFiltradasInicial = res.filter((gira) => gira.gir_anio === anioActual);
                setGirasFiltradas(girasFiltradasInicial);
               
            }

            const fetchReporteGiras = async () => {
                const res = await getReporteGiras();
              
                setReporteGiras(res.data);
            }

            fectchProgramas();
            fectchTramos();
           // fectchEstablecimientos();
            fecthregiones();
            fecthComunas();
            fetchTabla();  
            fetchReporteGiras(); 
           
        }, []);
    
    const floats = [
        { "title": "total_products", "digit": 547, "icon": "shopping_bag", "variant": "lg blue" }, 
        { "title": "total_categories", "digit": 605, "icon": "widgets", "variant": "lg green" },
        { "title": "total_barnds", "digit": 249, "icon": "verified_user", "variant": "lg purple" }
    ];

    const [showCreateGiraModal, setShowCreateGiraModal] = useState(false);
    const [giraData, setGiraData] = useState({
        programa: '',
        tramo: '',
        establecimientos: '',
        curso: '',
        region: '',
        comuna: '',
        valorGira: '',
        numeroCuotas: '',
        diaVencimientoCuota: '',
        fechaViaje: '',
        datosContacto: '',
        celularContacto: '',
        emailContacto: '',
        pagoInicial:0,
        liberados:0,
        anio: 2025,
        aplicaMultas: true,
        multaMensual: false,
        porcMulta: 1,
    });

    const handleShowCreateGiraModal = () => setShowCreateGiraModal(true);
    const handleCloseCreateGiraModal = () => setShowCreateGiraModal(false);

    // Funciones para el modal de reporte de pagos
    const handleShowReportModal = () => setShowReportModal(true);
    const handleCloseReportModal = () => setShowReportModal(false);

    // Funciones para el modal de reporte de tallas
    const handleShowReportTallasModal = () => setShowReportTallasModal(true);
    const handleCloseReportTallasModal = () => setShowReportTallasModal(false);

    const handleReportInputChange = (event) => {
        const { name, value } = event.target;
        setReportData({
            ...reportData,
            [name]: value
        });
    };

    const handleReportTallasInputChange = (event) => {
        const { name, value } = event.target;
        setReportTallasData({
            ...reportTallasData,
            [name]: value
        });
    };

    const handleGenerateReport = async () => {
        try {
            console.log('Generando reporte de pagos:', reportData);
            
            // Llamada a la API para generar el reporte usando el método getReportePagos
            const blob = await getReportePagos(reportData.fechaInicio, reportData.fechaFin);
            
            if (blob && !blob.error) {
                // Crear un enlace para descargar el archivo
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `reporte_pagos_${reportData.fechaInicio}_${reportData.fechaFin}.xlsx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                Swal.fire({
                    icon: 'success',
                    title: 'Reporte Generado',
                    text: `El reporte de pagos ha sido descargado exitosamente`
                });
            } else {
                throw new Error('Error al generar el reporte');
            }
        } catch (error) {
            console.error('Error al generar el reporte:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al generar el reporte de pagos: ' + error.message
            });
        }

        handleCloseReportModal();
    };

    const handleGenerateReportTallas = async () => {
        try {
            console.log('Generando reporte de tallas:', reportTallasData);
            
            // Llamada a la API para generar el reporte de tallas
            const blob = await getReporteTallas(reportTallasData.anio);
            
            if (blob && !blob.error) {
                // Crear un enlace para descargar el archivo
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `reporte_tallas_${reportTallasData.anio}.xlsx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                Swal.fire({
                    icon: 'success',
                    title: 'Reporte Generado',
                    text: `El reporte de tallas para el año ${reportTallasData.anio} ha sido descargado exitosamente`
                });
            } else {
                throw new Error('Error al generar el reporte');
            }
        } catch (error) {
            console.error('Error al generar el reporte:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al generar el reporte de tallas: ' + error.message
            });
        }

        handleCloseReportTallasModal();
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setGiraData({
            ...giraData,
            [name]: value
        });
    };

    const handleCreateGira = () => {
        // Aquí puedes manejar la lógica para crear la gira de estudios
    
        creaGira(giraData)
        .then(res => {
          Swal.close();
       //  fetchTabla();
          if (res.error === false) {
            Swal.fire({
              icon: 'success',
              text: 'Gira creada correctamente.'
            })
            cargaTabla();
            //navigateTo(ROUTES.USUARIOS);
          }
          else {
            let errorMsg = res.msg;
            if (res.errores) {
              errorMsg += '<table class="w-full leading-normal text-md bg-white"><thead><tr class="border-b-2 table-main font-semibold text-xs text-gray-600 uppercase tracking-wider"><th class="px-5 py-3 text-center">ID Manzanas</th><tbody>';
              res.errores.forEach(error => {
                errorMsg += `<tr class="border-b cursor-pointer text-gray-800"><td>${error}</td></tr>`;
              });
              errorMsg += '</tbody></table>';
            }

            Swal.fire({
              icon: 'error',
            
              html: errorMsg
            })
          }

        });
      
        handleCloseCreateGiraModal();
    };

    const handleRegionChange = (event) => {
        const { value } = event.target;
        setGiraData({
            ...giraData,
            region: value,
            comuna: '' // Reset comuna when region changes
        });
        // Fetch comunas based on selected region
        fetchComunas(value);
    };

     const handleComunaChange = (event) => {
        const { value } = event.target;
        setGiraData({
            ...giraData,
            comuna: value 
        });
        // Fetch comunas based on selected region
        fetchEstablecimientos(value);
    };

    const cargaTabla = async () => {
        const res = await getGiras();
        setGiras(res);
        setGirasFiltradas(res);
    }

    const fetchComunas = (regionId) => {
        // Replace with your actual API call
        const fetchedComunas = selectComuna.filter(comuna => comuna.reg_id === parseInt(regionId));
        console.log(fetchedComunas);
        setComunas(fetchedComunas);
    };

    const fetchEstablecimientos = async (comunaId) => {
        // Replace with your actual API call
       /* const fetchedComunas = selectComuna.filter(comuna => comuna.reg_id === parseInt(regionId));
        console.log(fetchedComunas);
        setComunas(fetchedComunas);*/
         const res = await getEstablecimientos(comunaId);
        console.log(res);
        setSelectEstablecimiento(res.data);
    };


    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">Giras de Estudios</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">{t('home')}</Link></li>
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">Administración</Link></li>
                                <li className="mc-breadcrumb-item">Giras</li>
                            </ul>
                        </div>
                    </div>
                </Col>
                {reporteGiras.map((float, index) => (
                    <Col key={ index } sm={6} lg={4}>
                        <FloatCardComponent 
                            variant={ float.variant }
                            digit={n(float.digit)}
                            title={t(float.title)}
                            icon={ float.icon }
                        />
                    </Col>
                ))}
                 <Col sm={6} lg={8}>
                    <div className="d-flex flex-wrap gap-2 mb-3">
                        <Button variant="primary" onClick={handleShowCreateGiraModal}>
                            Crear Gira de Estudios
                        </Button>

                        {(usuario?.roles?.[0]?.codigo === "ADMIN" || usuario?.roles?.[0]?.codigo === "MASTER") && (
                            <>
                                <Button variant="success" onClick={handleShowReportModal}>
                                    Reporte de Pagos
                                </Button>
                                <Button variant="info" onClick={handleShowReportTallasModal}>
                                    Reporte de Tallas
                                </Button>
                            </>
                        )}
                    </div>
                </Col>
                <Col sm={6} lg={4}>
                    <Form.Group controlId="formAnioFiltro">
                        <Form.Label>Filtrar por Año</Form.Label>
                        <Form.Select
                            value={anioFiltro}
                            onChange={(e) =>{ setAnioFiltro(Number(e.target.value)); const girasFiltradas = giras.filter((gira) => gira.gir_anio === Number(e.target.value)); console.log(e.target.value); setGirasFiltradas(girasFiltradas)}}
                        >
                            {anios.map((year) => (
                                <option key={year} value={year} selected={year === anioActual}>
                                    {year}
                                </option>
                            ))}
                        
                        </Form.Select>
                    </Form.Group>
                </Col>
                
                <Col xl={12}>
                    <div className="mc-card">
                        <Row>
                            
                            <Col xl={12}>
                                 <div className="mc-table-responsive">
                                            <table className="mc-table product">
                                                <thead className="mc-table-head primary">
                                                    <tr>
                                                       
                                                        {products.thead?.map((item, index) => (
                                                            <th key={ index }>{ t(item) }</th>
                                                        ))}
                                                    </tr>
                                                </thead>
                                                <tbody className="mc-table-body even">
                                                    {girasFiltradas?.map((item, index) => (
                                                        <tr key={ index }> 
                                                            <td>
                                                            { item.gir_id }  
                                                            </ td>
                                                            <td>
                                                                <div className="mc-table-product md">
                                                                   
                                                                    <div className="mc-table-group">
                                                                        <h6>{ item.est_nombre }</h6>
                                                                      
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>{ item.gir_curso }</td>
                                                            <td>{ item.programa }</td>
                                                            <td>{ item.tramo }</td>
                                                            <td>{ item.reg_nombre }</td>
                                                            <td>
                                                               { item.com_nombre }
                                                                    
                                                               
                                                            </td>
                                                            <td> { item.status === "approved" && <p className="mc-table-badge green">{ item.status }</p> }
                                                                { item.status === "pending" && <p className="mc-table-badge purple">{ item.status }</p> }
                                                                { item.status === "blocked" && <p className="mc-table-badge red">{ item.status }</p> }</td>
                                                           
                                                            
                                                            <td>
                                                                <div className="mc-table-action">
                                                                    <AnchorComponent to={{
                                                                          pathname: "/ver-gira",
                                                                          search: "?gira="+item.gir_id,
                                                                    }} title="View" className="material-icons view"><i className='material-icons'>search</i></AnchorComponent>
                                                                    
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                
                                           
                                        </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>

            <Modal show={showCreateGiraModal} onHide={handleCloseCreateGiraModal}>
            <div className="mc-alert-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Crear Gira de Estudios</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                    <Form.Group controlId="formAnio">
                            <Form.Label>Año</Form.Label>
                            <Form.Control type="text" name="anio" value={giraData.anio} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formPrograma">
                            <Form.Label>Programa</Form.Label>
                            <Form.Select name="programa" onChange={handleInputChange} >
                                <option>Seleccionar Programa</option>
                                {selectPrograma?.map((programa) => (
                                    <option key={programa.id} value={programa.id}>{programa.nombre}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="formTramo">
                            <Form.Label>Tramo</Form.Label>
                            <Form.Select name="tramo" onChange={handleInputChange} >
                                <option>Seleccionar Tramo</option>
                                {selectTramo?.map((tramo) => (
                                    <option key={tramo.id} value={tramo.id}>{tramo.nombre}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="formAplicaMultas">
                        <Form.Label>Aplicar Multas</Form.Label>
                            <Form.Check
                                type="checkbox"
                                
                                name="aplicaMultas"
                                checked={giraData.aplicaMultas}
                                onChange={(e) =>
                                    setGiraData({
                                        ...giraData,
                                        aplicaMultas: e.target.checked
                                    })
                                }
                            />
                        </Form.Group>
                         <Form.Group controlId="formultaMensual">
                        <Form.Label>Multas Mensuales (si se deja desactivada se calcula por semana)</Form.Label>
                            <Form.Check
                                type="checkbox"
                                
                                name="multaMensual"
                                checked={giraData.multaMensual}
                                onChange={(e) =>
                                    setGiraData({
                                        ...giraData,
                                        multaMensual: e.target.checked
                                    })
                                }
                            />
                        </Form.Group>
                         <Form.Group controlId="formValorGira">
                            <Form.Label>Porcentaje Multa</Form.Label>
                            <Form.Control type="text" name="porcMulta" value={giraData.porcMulta} onChange={handleInputChange} />
                        </Form.Group>
                         <Form.Group controlId="formRegion">
                            <Form.Label>Región</Form.Label>
                            <Form.Select  name="region" value={giraData.region} onChange={handleRegionChange} >
                                <option>Seleccionar Región</option>
                                {selectRegion?.map((region) => (
                                    <option key={region.id} value={region.id}>{region.nombre}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="formComuna">
                            <Form.Label>Comuna</Form.Label>
                            <Form.Select type="text" name="comuna" value={giraData.comuna} onChange={handleComunaChange} >
                                <option>Seleccionar Comuna</option>
                                {comunas?.map((comuna) => (
                                    <option key={comuna.com_id} value={comuna.com_id}>{comuna.com_nombre}</option>
                                ))}
                            </Form.Select>    
                        </Form.Group>
                        <Form.Group controlId="formEstablecimientos">
                            <Form.Label>Establecimientos</Form.Label>
                            <Form.Select name="establecimientos" onChange={handleInputChange} >
                                <option>Seleccionar Establecimiento</option>
                                {selectEstablecimiento?.map((establecimiento) => (
                                    <option key={establecimiento.id} value={establecimiento.id}>{establecimiento.nombre}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="formCurso">
                            <Form.Label>Curso</Form.Label>
                            <Form.Control type="text" name="curso" value={giraData.curso} onChange={handleInputChange} />
                        </Form.Group>
                       
                        <Form.Group controlId="formValorGira">
                            <Form.Label>Precio Unitario Gira</Form.Label>
                            <Form.Control type="number" name="valorGira" value={giraData.valorGira} onChange={handleInputChange} />
                        </Form.Group>
                        
                        <Form.Group controlId="formNumeroCuotas">
                            <Form.Label>Número de Cuotas</Form.Label>
                            <Form.Control type="number" name="numeroCuotas" value={giraData.numeroCuotas} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formDiaVencimientoCuota">
                            <Form.Label>Día Vencimiento Cuota</Form.Label>
                            <Form.Control type="number" name="diaVencimientoCuota" value={giraData.diaVencimientoCuota} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formLiberados">
                            <Form.Label>Liberados</Form.Label>
                            <Form.Control type="text" name="liberados" value={giraData.liberados} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formFechaViaje">
                            <Form.Label>Fecha del Viaje</Form.Label>
                            <Form.Control type="date" name="fechaViaje" value={giraData.fechaViaje} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formDatosContacto">
                            <Form.Label>Nombre del Responsable Curso</Form.Label>
                            <Form.Control type="text" name="datosContacto" value={giraData.datosContacto} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formDatosContacto">
                            <Form.Label>Celular del Responsable Curso</Form.Label>
                            <Form.Control type="text" name="celularContacto" value={giraData.celularContacto} onChange={handleInputChange} />
                        </Form.Group>
                        <Form.Group controlId="formDatosContacto">
                            <Form.Label>Email del Responsable Curso</Form.Label>
                            <Form.Control type="text" name="emailContacto" value={giraData.emailContacto} onChange={handleInputChange} />
                        </Form.Group>
                        
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseCreateGiraModal}>
                        Cerrar
                    </Button>
                    <Button variant="primary" onClick={handleCreateGira}>
                        Crear
                    </Button>
                </Modal.Footer>
                </div>
            </Modal>

            {/* Modal para Reporte de Pagos */}
            <Modal show={showReportModal} onHide={handleCloseReportModal}>
                <div className="mc-alert-modal">
                    <Modal.Header closeButton>
                        <Modal.Title>Generar Reporte de Pagos</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group controlId="formFechaInicio">
                                <Form.Label>Fecha de Inicio</Form.Label>
                                <Form.Control 
                                    type="date" 
                                    name="fechaInicio" 
                                    value={reportData.fechaInicio} 
                                    onChange={handleReportInputChange} 
                                />
                            </Form.Group>
                            <Form.Group controlId="formFechaFin" className="mt-3">
                                <Form.Label>Fecha de Fin</Form.Label>
                                <Form.Control 
                                    type="date" 
                                    name="fechaFin" 
                                    value={reportData.fechaFin} 
                                    onChange={handleReportInputChange} 
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseReportModal}>
                            Cerrar
                        </Button>
                        <Button variant="success" onClick={handleGenerateReport}>
                            Generar Reporte
                        </Button>
                    </Modal.Footer>
                </div>
            </Modal>

            {/* Modal para Reporte de Tallas */}
            <Modal show={showReportTallasModal} onHide={handleCloseReportTallasModal}>
                <div className="mc-alert-modal">
                    <Modal.Header closeButton>
                        <Modal.Title>Generar Reporte de Tallas de Poleras</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group controlId="formAnioReporte">
                                <Form.Label>Año</Form.Label>
                                <Form.Select
                                    name="anio"
                                    value={reportTallasData.anio}
                                    onChange={handleReportTallasInputChange}
                                >
                                    {anios.map((year) => (
                                        <option key={year} value={year}>
                                            {year}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseReportTallasModal}>
                            Cerrar
                        </Button>
                        <Button variant="info" onClick={handleGenerateReportTallas}>
                            Generar Reporte
                        </Button>
                    </Modal.Footer>
                </div>
            </Modal>
        </PageLayout>
    );
}
